import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import LoadingSkeleton from './LoadingSkeleton';
import MetadataCard from './MetadataCard';
import ipfsService from '../services/IPFSService';

const ResultDisplay = ({ isLoading, error, nftData }) => {
  // Loading state
  if (isLoading) {
    return <LoadingSkeleton />;
  }

  // Error state
  if (error) {
    return (
      <Box mt={3} mb={3}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  // No data placeholder
  if (!nftData || !nftData.contractInfo) {
    return (
      <Box sx={{ mt: 4, textAlign: 'center', py: 8 }}>
        <Typography variant="h6" color="text.secondary">
          Enter an Evidencer record number above to view details
        </Typography>
      </Box>
    );
  }

  // Extract data
  const { contractInfo, tokenDetails, ipfsContent } = nftData;
  const { metadata, imageURL } = ipfsContent || {};

  // Display metadata using enhanced MetadataCard
  return (
    <MetadataCard
      name={contractInfo.name}
      symbol={contractInfo.symbol}
      ownerOf={tokenDetails.ownerOf}
      tokenURI={tokenDetails.tokenURI && ipfsService.getPrimaryGatewayUrl(tokenDetails.tokenURI)}
      tokenContent={metadata}
      imageURL={imageURL}
      tokenId={tokenDetails.tokenId}
    />
  );
};

export default ResultDisplay;